import { render, staticRenderFns } from "./MainMenuBar.vue?vue&type=template&id=2cea9477&scoped=true&"
import script from "./MainMenuBar.vue?vue&type=script&lang=js&"
export * from "./MainMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea9477",
  null
  
)

export default component.exports